var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/icons/PointerDown.tsx"; // This file was auto-generated using scripts/generate-icons.js
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Icon generated from pointer-down.svg
 */
export default function PointerDownIcon(props) {
  return _jsxDEV("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "9",
    "data-component": "PointerDownIcon",
    ...props,
    children: _jsxDEV("path", {
      stroke: "currentColor",
      d: "m15.5 0-7 8-8-8"
    }, void 0, false, {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=PointerDown.js.map